import { useAuth0 } from "@auth0/auth0-react";
import { Button, EmptyState, Flex, Heading, Icons, Paragraph } from "@ir/ui";
import { PageContent } from "@src/presentation/components/Layout/common";
import { AdminAuthLoginService } from "@src/infrastructure/auth/AdminAuthLoginService";

export const AdminAuthProviderError = () => {
  const { logout } = useAuth0();

  const handleRetry = async () => {
    await AdminAuthLoginService.getInstance().logout();
    await logout();
  };

  return (
    <PageContent>
      <Flex
        align="center"
        justifyContent="center"
        style={{ height: "100vh", backgroundColor: "var(--white-color)" }}
      >
        <EmptyState
          className="px-4 py-5 m-4"
          icon={Icons.InfoOctagon}
          title={
            <Heading level={3} className="text-grey-700 font-bold mt-3">
              412 - Error processing request
            </Heading>
          }
          description={
            <Paragraph className="text-grey-500 font-regular mb-0">
              There was a problem processing your request. Please try again, or
              contact support if the issue persists
            </Paragraph>
          }
        >
          <Button
            onPress={() => {
              void handleRetry();
            }}
            className="mt-5"
          >
            Retry
          </Button>
        </EmptyState>
      </Flex>
    </PageContent>
  );
};
